import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    description: 'You must assign it an invoice number.',
    errorMessage:
      'An error occurred while marking your invoice as sent. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    submit: 'Mark as sent',
    successMessage: 'Your invoice n°{0} has been successfully marked as sent!',
    title: 'Mark your invoice as sent',
  },
  fr: {
    cancel: 'Annuler',
    description: 'Vous devez lui attribuer un numéro de facture.',
    errorMessage:
      'Une erreur est survenue lors du marquage de votre facture comme envoyée. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    submit: 'Marquer comme envoyée',
    successMessage: 'Votre facture n°{0} a bien été marquée comme envoyée\xA0!',
    title: 'Marquer votre facture comme envoyée',
  },
} as const);
